<template>
  <v-layout>
    <v-app-bar height="62" :elevation="0" class="top-navbar" :style="topNavStyle">

      <ProjectSelection v-if="false" />
      <AccountSelection v-if="false" />

      <!-- ── LEFT ── -->
      <div class="tn-left">

        <!-- User card -->
        <div class="tn-user-card">
          <div class="tn-avatar">
            <span class="tn-avatar__text">{{ userInitials }}</span>
            <span class="tn-avatar__ring"></span>
            <span class="tn-avatar__status"></span>
          </div>
          <div class="tn-identity">
            <span class="tn-identity__greet">{{ greetingText }}</span>
            <div class="tn-identity__name-row">
              <div class="tn-identity__name">
                {{ userName }}
                <v-tooltip activator="parent" location="bottom">{{ userName }}</v-tooltip>
              </div>
              <button class="tn-edit-btn" id="tm-nextaction-activator" v-if="showEdit">
                <v-icon size="10" color="rgba(147,197,253,0.6)">mdi-pencil</v-icon>
              </button>
            </div>
          </div>
        </div>

        <div class="tn-sep" />

        <!-- Meta badges -->
        <div class="tn-meta">
          <div class="tn-badge tn-badge--role" v-if="userData && userData.roles">
            <v-icon size="9" color="#a5b4fc">mdi-shield-account-outline</v-icon>
            <span>{{ userData.roles.code }}</span>
          </div>
          <div class="tn-badge tn-badge--shift" v-if="workTiming && workTiming.name">
            <v-icon size="9" color="#6ee7b7">mdi-clock-time-four-outline</v-icon>
            <span>{{ workTiming.name }}</span>
          </div>
          <span class="tn-online-dot"></span>
        </div>

        <div class="tn-sep" />
        <!-- Date navigator (dashboard only, hidden when meeting/break timer is running) -->
        <template v-if="$route.path === '/' && !meetingTimer && !isActiveMeetingOrBreak">
          <div class="tn-date-nav">
            <!-- <button class="tn-arrow-btn" @click="navigateTimesheetDate('prev')" title="Previous day">
              <v-icon size="14" color="rgba(255,255,255,0.7)">mdi-chevron-left</v-icon>
            </button> -->

            <v-menu v-model="datePickerMenu" :close-on-content-click="false" location="bottom center">
              <template v-slot:activator="{ props }">
                <div class="tn-date-display tn-date-display--clickable" v-bind="props" title="Pick a date">
                  <v-icon size="11" color="#7dd3fc">mdi-calendar-blank-outline</v-icon>
                  <span class="tn-date-display__text">{{ timesheetDateLabel }}</span>
                  <v-icon size="10" color="rgba(125,211,252,0.6)">mdi-chevron-down</v-icon>
                </div>
              </template>
              <v-card class="tn-datepicker-card" elevation="0">
                <v-date-picker
                  :model-value="timesheetActiveDate"
                  @update:model-value="onDatePickerSelect"
                  :max="new Date()"
                  color="#3b82f6"
                  show-adjacent-months
                  hide-header
                />
              </v-card>
            </v-menu>

            <!-- <button class="tn-arrow-btn" @click="navigateTimesheetDate('next')"
              :disabled="isTimesheetToday" :class="{ 'tn-arrow-btn--off': isTimesheetToday }" title="Next day">
              <v-icon size="14" :color="isTimesheetToday ? 'rgba(255,255,255,0.18)' : 'rgba(255,255,255,0.7)'">mdi-chevron-right</v-icon>
            </button> -->
          </div>
        </template>

      </div>

      <!-- ── CENTER — My Space + Meeting ── -->
      <div class="tn-center" :class="{ 'tn-center--shifted': meetingTimer }">
        <div class="tn-center-cluster">

          <!-- My Space -->
          <v-menu location="bottom" v-model="menu" :close-on-content-click="false">
            <template v-slot:activator="{ props }">
              <button class="tn-myspace-btn" v-bind="props">
                <!-- <span class="tn-myspace-shimmer"></span> -->
                <span class="tn-myspace-icon-wrap">
                  <v-icon size="15" color="#fff">mdi-telescope</v-icon>
                </span>
                <span class="tn-myspace-text-wrap">
                  <span class="tn-myspace-eyebrow">workspace</span>
                  <span class="tn-myspace-label">My Space</span>
                </span>
                <v-icon size="11" class="tn-myspace-chevron">mdi-chevron-down</v-icon>
              </button>
            </template>
            <workSpaceCard @closeMenu="closedMenu()" />
          </v-menu>

        </div>
      </div>

      <!-- ── RIGHT ── -->
      <template v-slot:append>

        <!-- Timer -->
        <div class="tn-timer-wrap" v-if="((($route.path != '/') || meetingTimer) && !timerDialog && $route.path != '/issueView2') || showIBT">
          <Timer
            :timerInProgress="getTimerInProgress" :title="timerTitle" :showHomeCard="false"
            :showInBetweenTime="showIBT"
            v-on:closeDialog1="closeTimerDialog($event)"
            @openTimer="openTimerDialog()"
            v-on:openDialog="openDialog" />
          <div class="tn-sep tn-sep--r" />
        </div>

        <!-- Activity group -->
         <!-- Meeting -->
        <div class="mr-1">
          <button class="tn-meeting-btn" id="meeting-menu-activator">
            <span class="tn-meeting-pulse"></span>
            <!-- <span class="tn-meeting-shimmer"></span> -->
            <span class="tn-meeting-icon-wrap">
              <v-icon size="14" color="#fff">mdi-headset</v-icon>
            </span>
            <span class="tn-meeting-text-wrap">
              <span class="tn-meeting-eyebrow">start</span>
              <span class="tn-meeting-label">Meeting</span>
            </span>
            <v-tooltip activator="parent" location="bottom">Start Meeting</v-tooltip>
          </button>
        </div>

        <div class="tn-sep tn-sep--r" />

        <div class="tn-pill-group mx-1">
          <template v-if="!breakLoader">
            <button class="tn-pill-btn" @click="startBreak()">
              <img class="tn-pill-btn__img" src="https://new-synergy-snaps.s3.ap-south-1.amazonaws.com/public/icons/cupcake.svg">
              <v-tooltip activator="parent" location="bottom">Break</v-tooltip>
            </button>
          </template>
          <v-progress-circular v-else color="rgba(255,255,255,0.6)" size="15" width="2" indeterminate class="mx-2" />

          <button class="tn-pill-btn" @click="getReviewTimeSheets()">
            <i class="pi pi-stopwatch tn-pill-btn__pi"></i>
            <v-tooltip activator="parent" location="bottom">Timesheets</v-tooltip>
          </button>
        </div>

        <div class="tn-sep tn-sep--r" />

        <!-- Navigation group -->
        <div class="tn-pill-group mx-1">
          <button class="tn-pill-btn" @click="$router.push('/')">
            <v-icon size="17" color="rgba(255,255,255,0.72)">mdi-home-outline</v-icon>
            <v-tooltip activator="parent" location="bottom">Home</v-tooltip>
          </button>

          <button class="tn-pill-btn" @click="openReceivedReplay">
            <v-icon size="17" color="rgba(255,255,255,0.72)">mdi-email-receive-outline</v-icon>
            <v-tooltip activator="parent" location="bottom">Received Reply</v-tooltip>
          </button>

          <button class="tn-pill-btn" @click="openTeamStatus()">
            <v-icon size="17" color="rgba(255,255,255,0.72)">mdi-account-group-outline</v-icon>
            <v-tooltip activator="parent" location="bottom">Team Status</v-tooltip>
          </button>
        </div>

        <div class="tn-sep tn-sep--r" />

        <!-- Workspaces -->
        <!-- <WorkspaceSelection displayType="avatar" /> -->

        <!-- <div class="tn-sep tn-sep--r" /> -->

        <!-- Search -->
        <div class="d-flex align-center">
          <SearchIssues
            v-if="currentOption === 'Refnum_search' || currentOption === 'Subject_search'"
            :subject="currentOption === 'Subject_search'" />
          <button class="tn-pill-btn" @click="currentOption = 'searchIcon'"
            v-if="currentOption === 'Refnum_search' || currentOption === 'Subject_search'">
            <v-icon size="15" color="rgba(255,255,255,0.72)">mdi-close</v-icon>
          </button>
          <button class="tn-pill-btn" v-show="currentOption === 'searchIcon'" id="search-activator">
            <v-icon size="17" color="rgba(255,255,255,0.72)">mdi-magnify</v-icon>
            <v-tooltip activator="parent" location="bottom">Search</v-tooltip>
          </button>
        </div>

        <!-- Add -->
        <button class="tn-add-btn" @click="goAddTask()">
          <v-icon size="17" color="#fff">mdi-plus</v-icon>
          <v-tooltip activator="parent" location="bottom">Add Task</v-tooltip>
        </button>

        <!-- Profile -->
        <button class="tn-profile-btn" id="menu-activator">
          <span class="tn-profile-btn__initials">{{ userInitials }}</span>
          <span class="tn-profile-btn__status"></span>
          <v-tooltip activator="parent" location="bottom">Profile</v-tooltip>
        </button>

        <MenuOptions @menu-selected="selectedOption" :options="forSearchOption" activator="#search-activator" />
        <MenuOptions @menu-selected="logOut($event)" :options="userProfileOptions" activator="#menu-activator" />
        <MenuOptions @menu-selected="startMeeting($event, true)" :options="meetingTasks" activator="#meeting-menu-activator" />
      </template>
    </v-app-bar>
  </v-layout>

  <v-dialog persistent :width="300" v-model="timerDialog">
    <Timer :timerInProgress="getTimerInProgress" :showHomeCard="false" :title="timerTitle" :timerName="timerName"
      v-on:closeTimerDialog="minimizeTimer()" v-on:closeDialog1="closeTimer($event)" :taskType="taskType"
      :showPlay="true" :hideCard="true" />
  </v-dialog>

  <NavigationDrawer ref="NavigationDrawer" />
  <TeamStatus ref="TeamStatus" />
  <ReceivedReplay ref="ReceivedReplay" />
  <ImpersonateUser :showDialog="showImpersonateDialog" @close-dialog="closeImpersonateDialog()" />

  <v-dialog persistent :width="600" v-model="maDialog">
    <MeetingAccountSelection :data="meetingData" @closeDialog="maDialog = false"
      @account-selection="againStartMeeting" />
  </v-dialog>

  <NextAction activator="#tm-nextaction-activator" :options="reporterUsers" @menuSelected="onUserSelected" :showAvatar="true" />
</template>

<script>
import TeamStatus from './TeamStatus.vue'
import ImpersonateUser from '@/modules/users/ImpersonateUser.vue'
import workSpaceCard from '@/modules/dashboard/user/workSpaceCard.vue';
import Timer from './Timer.vue'
import MenuOptions from './MenuOptions.vue'
import AccountSelection from './AccountSelection.vue'
import TimeSheetService from '@/api/service/TimeSheet/TimeSheetService.js';
import lodash from "lodash";
import TimerService from '@/api/service/TimeSheet/TimerService'
import moment from 'moment'
import UserService from '@/api/service/UserService';
// import TaskService from "@/api/service/Task/TaskService"
import IssueService from "@/api/service/Issue/IssueService";
// import WorkspaceSelection from "./WorkspaceSelection.vue";
import ProjectSelection from './ProjectSelection.vue'
// import Notification from "@/modules/Notification/Notification.vue";
import NavigationDrawer from "./NavigationDrawer.vue";
import ReceivedReplay from "./ReceivedReplay.vue"
import AccountService from "@/api/service/Account/AccountService";
import ProjectService from "@/api/service/Project/ProjectService";
import WorkSpaceService from "@/api/service/WorkSpace/WorkSpaceService";
import SearchIssues from "@/components/ui/SearchIssues.vue";
import TaskService from '@/api/service/Task/TaskService'
// import { getSocket } from "@/components/socketio/socket";
import MeetingAccountSelection from './MeetingAccountSelection.vue';
import NextAction from '@/modules/IssueV2/NextAction.vue';
// import HuddleDialog from './HuddleDialog.vue';
// import commonService from '@/common.service';
// import HuddleDetailsService from '@/api/service/HuddleDetails/HuddleDetailsService';
// import RoleService from '@/api/service/Role/RoleService';
// import SetTimer from '@/modules/settings/Others/SetTimer.vue';
export default {
  components: {
    ImpersonateUser,
    TeamStatus,
    workSpaceCard,
    Timer,
    NavigationDrawer,
    ReceivedReplay,
    // Notification,
    // WorkspaceSelection,
    AccountSelection,
    MenuOptions,
    ProjectSelection,
    SearchIssues,
    MeetingAccountSelection,
    NextAction,
    // HuddleDialog
    // SetTimer,
  },

  data() {
    return {
      user_activity_id: null,
      showImpersonateDialog: false,
      meetingTasks: [],
      huddleTaskData: [],
      // count:null,
      activated: false,
      breakLoader: false,
      maDialog: false,
      huddle: false,
      timerRunning: false,
      dialog: false,
      timerDialog: false,
      meetingTimer: false,
      timerShow: false,
      fav: true,
      menu: false,
      menuTeam: false,
      timerTitle: '',
      timerName: '',
      message: false,
      hideTimer: false,
      hints: true,
      show: false,
      avatarName: null,
      maxAvatarLabelCount: 4,
      // colors: ["#2196F3", "#4CAF50", "#FF9800", "#9C27B0", "#F44336"],
      currentTime: '',
      currentDate: '',
      clockInterval: null,
      timesheetActiveDate: new Date(),
      datePickerMenu: false,
      userData: null,
      selectedDisplayUser: null,
      workTiming: { name: null },
      showEdit: false,
      reporterUsers: [],
      meetingData: null,
      workSpaceData: [],
      projectData: [],
      accountData: [],
      addedMenu: [],
      host: window.location.host,
      workTimingId:'',
      showIBT:false,
      currentOption: 'searchIcon',
      userProfileOptions: [
        { title: "User Profiles", "action": "/user" },
        { title: "Logout" }
      ],
      forSearchOption: [
        {title: "Ref Num"},
        {title: "Subject"}
      ],
      // addMenuOptions removed — Add Task uses goAddTask() which routes through existing screens
    };
  },
  watch: {
    refreshProject() {
      if (this.$store.getters.getWorkSpaceId) {
        localStorage.setItem('workSpaceId', this.$store.getters.getWorkSpaceId)
        localStorage.removeItem("_PROJECT_ID_");
        localStorage.removeItem("_ACCOUNT_ID_");
        this.getProjectData();
        this.getAccountData();
      }
    },
    getInBetweenTime() {
      this.checkInBetweenTime()
    },
    getWorkTimingFromStore(val) {
      if (val) {
        this.workTiming = val;
      }
    },
  },

  computed: {
    checkRoute() {
      return window.location.pathname
    },
    getRailExpanded() {
      return this.$store.getters.getRailExpanded;
    },
    topNavStyle() {
      const sideWidth = this.getRailExpanded ? '230px' : '64px';
      return {
        left: `calc(${sideWidth} + 8px)`,
        width: `calc(100% - ${sideWidth} - 16px)`,
        transition: 'left 0.28s cubic-bezier(0.4,0,0.2,1), width 0.28s cubic-bezier(0.4,0,0.2,1)'
      };
    },
    userInitials() {
      const u = this.selectedDisplayUser || this.userData;
      if (!u) return 'U';
      const first = u.first_name ? u.first_name[0] : '';
      const last = u.last_name ? u.last_name[0] : '';
      return (first + last).toUpperCase() || 'U';
    },
    userName() {
      const u = this.selectedDisplayUser || this.userData;
      if (!u) return 'User';
      return [u.first_name, u.last_name].filter(Boolean).join(' ') || u.name || 'User';
    },
    greetingText() {
      const h = new Date().getHours();
      if (h < 12) return 'Good Morning';
      if (h < 17) return 'Good Afternoon';
      return 'Good Evening';
    },
    isTimesheetToday() {
      const t = new Date();
      const d = this.timesheetActiveDate;
      return d.getFullYear() === t.getFullYear() && d.getMonth() === t.getMonth() && d.getDate() === t.getDate();
    },
    timesheetDateLabel() {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      const same = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
      if (same(this.timesheetActiveDate, today)) return 'Today';
      if (same(this.timesheetActiveDate, yesterday)) return 'Yesterday';
      return moment(this.timesheetActiveDate).format('MMM DD, YYYY');
    },
    getTimerInProgress() {
      return this.$store.getters.getInProgress
    },
    refreshProject() {
      return this.$store.getters.getWorkSpaceId;
    },
    getInBetweenTime() {
      return this.$store.getters.getInBetweenTime
    },
    getWorkTimingFromStore() {
      return this.$store.getters.getWorkTiming
    },
  },
  mounted() {
    this.updateClock();
    this.clockInterval = setInterval(this.updateClock, 1000);
    this.$store.commit('SET_TIMESHEET_DATE', moment(new Date()).format('YYYY-MM-DD'));
  },
  beforeUnmount() {
    clearInterval(this.clockInterval);
  },
  created() {
    let timerData = JSON.parse(localStorage.getItem("timer"))
    this.showIBT = this.getInBetweenTime == true ? true : false
    if (timerData && timerData.type && timerData.type != process.env.VUE_APP_IBT_CODE) {
      this.showIBT = false
      const isMeetingOrBreak = timerData.type !== 'issue'
      this.timerDialog = isMeetingOrBreak
      // If a meeting/break is already running on load, show the minimized timer (not dialog)
      // so the date field is hidden correctly
      this.meetingTimer = false
      this.timerRunning = true
      if (this.$route.path.includes('issueView2')) {
        this.timerRunning = false
      }
      this.timerTitle = timerData.type ? timerData.type : 'meeting'
      this.timerName = timerData.type && timerData.type.toLowerCase() == 'meeting' ? timerData.meetingName : timerData.type
    }
    else if (timerData && timerData.type && timerData.type == process.env.VUE_APP_IBT_CODE) {
      this.showIBT = true
      this.timerRunning = false
      this.meetingTimer = false
      this.timerDialog = false
    }
    else {
      this.timerRunning = false
      this.meetingTimer = false
      this.timerDialog = false
    }
    this.extraAvatar();
    this.getWorkSpaceData();
    this.userData = JSON.parse(localStorage.getItem("user_details"));
    this.getAvatarMenu();
    this.getMeetingTasks();
    const $wt = localStorage.getItem("_WORK_TIMING_");
    if ($wt) this.workTiming = JSON.parse($wt);
    this.toShowEdit();
    this.getReporterUsers();
    // let $socket = getSocket();
    // console.log($socket, 'sockettttconehuddle')
    // if ($socket) {
    //   $socket.on("HUDLE_STARTED", ($huddle) => {
    //     console.log(" Hudle Meeeting started:", $huddle);
    //     let user = localStorage.getItem("user_details");
    //     let userData = user ? JSON.parse(user) : {};
    //     if (userData.id) {
    //       if ($huddle.user_id == userData.id) {
    //         if ($huddle.description) {
    //           let timerData = JSON.parse(localStorage.getItem("timer"));
    //           timerData.remarks = $huddle.description;
    //           localStorage.setItem("timer", JSON.stringify(timerData));
    //         }
    //         let hudleData = this.huddleTaskData.filter(f => f.code == 'HUD')
    //         this.startMeeting(hudleData[0], false)
    //       }
    //     }
    //   });
    // }
    // if ($socket) {
    //   $socket.on("HUDLE_STOPED", async ($huddle) => {
    //     console.log(" Hudle Meeeting stoped:", $huddle);
    //     let user = localStorage.getItem("user_details");
    //     let userData = user ? JSON.parse(user) : {};
    //     if (userData.id) {
    //       if ($huddle.user_id == userData.id) {
    //         let timerData = JSON.parse(localStorage.getItem("timer"));
    //         if ($huddle.description) {
    //           timerData.remarks = $huddle.description;
    //           localStorage.setItem("timer", JSON.stringify(timerData));
    //           await TimeSheetService.updateMeetingRemarks({
    //             description: $huddle.description
    //           });
    //         }
    //         this.closeTimer(timerData)
    //       }
    //     }
    //   });
    // }
  },

  methods: {
    updateClock() {
      const now = new Date();
      this.currentTime = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
      this.currentDate = now.toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
    },

    goAddTask() {
      // Set redirect so workspace/project/account screens return here after selection
      localStorage.setItem('_WS_REDIRECT_', '/addQuickIssue?from=topMenu');

      const $wsDefaults = localStorage.getItem('_WS_DEFAULTS_');
      const parsed = $wsDefaults ? JSON.parse($wsDefaults) : null;

      if (!parsed || !parsed.workspace) {
        this.$router.push('/showWorkspaces');
      } else if (!parsed.project) {
        this.$router.push('/showProjectForWorkspaces');
      } else if (!parsed.account) {
        this.$router.push('/showAccountForWorkspaces');
      } else {
        // All context already set — go straight to task creation
        localStorage.removeItem('_WS_REDIRECT_');
        this.$router.push({ path: '/addQuickIssue', query: { from: 'topMenu' } });
      }
    },

    truncateText(text, maxLength) {
      if (!text) return "";

      return text.length > maxLength
        ? text.substring(0, maxLength) + "..."
        : text;
    },
    toShowEdit() {
      if (this.userData && this.userData.roles) {
        this.showEdit = !['PL', 'PA', 'SPA'].includes(this.userData.roles.code);
      }
    },
    async getReporterUsers() {
      try {
        let res = await UserService.getReporterUserData();
        this.reporterUsers = res ? res : [];
        this.reporterUsers.unshift({ id: this.userData.id, name: 'My Space' });
      } catch (e) {
        this.reporterUsers = [];
      }
    },
    onUserSelected($item) {
      this.$store.commit('SET_SELECTED_DASHBOARD_USER', $item);
      this.selectedDisplayUser = $item && $item.id !== this.userData?.id ? $item : null;
    },
    navigateTimesheetDate(direction) {
      const d = new Date(this.timesheetActiveDate);
      if (direction === 'prev') {
        d.setDate(d.getDate() - 1);
      } else if (direction === 'next' && !this.isTimesheetToday) {
        d.setDate(d.getDate() + 1);
      }
      this.timesheetActiveDate = d;
      this.$store.commit('SET_TIMESHEET_DATE', moment(d).format('YYYY-MM-DD'));
    },
    onDatePickerSelect(date) {
      if (!date) return;
      const selected = new Date(date);
      const today = new Date();
      // Clamp to today if somehow a future date slips through
      if (selected > today) return;
      this.timesheetActiveDate = selected;
      this.$store.commit('SET_TIMESHEET_DATE', moment(selected).format('YYYY-MM-DD'));
      this.datePickerMenu = false;
    },
    selectedOption(option) {
      if(option.title === "Ref Num"){
        this.currentOption = "Refnum_search"
      }
      else{
        this.currentOption = "Subject_search"
      }  
    },
    getReviewTimeSheets(){
      this.$router.push('/timesheetreview')
    },
    checkInBetweenTime() {
      let timerData = localStorage.getItem("timer")
      timerData = timerData ? JSON.parse(timerData) : null
      this.showIBT = timerData && timerData.type && timerData.type == process.env.VUE_APP_IBT_CODE ? true : false
    },
    openDialog() {
      this.timerDialog = true
    },
    // async startHudleMeeting($formData) {
    //   console.log($formData, 'usremember2443')
    //   this.huddle = false
    //   let hudleData = this.huddleTaskData.filter(f => f.code == 'HUD')
    //   this.startMeeting(hudleData[0], false)
    //   let $hudleData = {
    //     work_space_id: JSON.stringify($formData.workSpace_id),
    //     account_id: JSON.stringify($formData.account_id),
    //     user_id: JSON.stringify($formData.user_id),
    //     stage: 'pending'
    //   }
    //   let $res = await HuddleDetailsService.create($hudleData)
    //   console.log($res.data.data, 'huddleres1727')
    //   localStorage.setItem('huddle', JSON.stringify($res.data.data))
    //   let $data = { socketName: 'HUDLE_STARTED', huddleId: $res.data.data.id }
    //   commonService.getSocketConnection($data)
    // },

    
    // startMeeting($selected, $checkStatus) {
    startMeeting($selected) {
      console.log($selected, "$selected !!!!")
      // alert(this.checkMeeting())
      if (this.checkMeeting()) {
        this.meetingData = $selected
        //  let checkCode = ['ME', 'CA', 'TR', 'MBS']
        if ($selected && $selected.code && $selected.account_required && $selected.account_required == 1) {
          this.maDialog = true
        }
        else {
          this.maDialog = false
          //alert(JSON.stringify($selected,null,4))
          // if ($selected.name !== 'Huddle' || !$checkStatus) {
            this.startTimer('meeting', $selected)
          // } else {
          //   this.huddle = true
          // }
        }
      }
      else {
        this.timerDialog = true
      }
    },
    startBreak() {
      // alert(this.checkMeeting())
      if (this.checkMeeting()) {
        this.startTimer('break')
      }
      else {
        this.timerDialog = true
      }
    },
    checkMeeting() {
      let timerData = localStorage.getItem("timer")
      timerData = timerData ? JSON.parse(timerData) : null
      if (timerData && timerData.type && timerData.type == 'meeting' && timerData.remarks_required && timerData.remarks_required == 1 && (!timerData.remarks || timerData.remarks.length == 0)) {
        return false
      }
      return true
    },
    againStartMeeting($selected) {
      this.maDialog = false
      this.meetingData = $selected
      this.startTimer('meeting', $selected)
    },
    async getMeetingTasks() {
      let $tasks = await TaskService.findAll({ "task_type": "meeting", active: 1 })
      // let res = await RoleService.findAll({ code: 'CA' });
      this.huddleTaskData = $tasks && $tasks.length > 0 ? JSON.parse(JSON.stringify($tasks)) : []
      // let userData = JSON.parse(localStorage.getItem("user_details"))
      // if (JSON.parse(userData.roles.role_type) > JSON.parse(res[0].role_type)) {
      //   let index = $tasks.findIndex(f => f.code == 'HUD')
      //   if (index > -1) {
      //     $tasks.splice(index, 1)
      //   }
      // }
      console.log($tasks, "$tasks!!!!")
      this.meetingTasks = $tasks;
    },
    closeImpersonateDialog() {

      this.showImpersonateDialog = false
    },
    atClick() {
      this.$router.push({ path: "/ProjectView" });
    },
    menuSelected($event) {
      console.log($event)
    },
    logOut($event) {
      let $timerData = JSON.parse(localStorage.getItem('timer'))
      if ($event.title == 'Logout') {
        if ($timerData && $timerData.type && $timerData.type != process.env.VUE_APP_IBT_CODE) {
          this.$store.dispatch('setSnackbar', { color: 'error', text: `Stop the running ${$timerData.type} before LOGOUT` })
        } else {
          this.$router.push('/logout')
        }
      }
    },
    closeTimerDialog($event) {
      if (!this.timerDialog) {
        console.log($event, 'evetn')
        this.closeTimer($event)
      }
    },
    async updateTimeSheet() {
      let issueData = JSON.parse(localStorage.getItem("timer"))
      if (issueData && issueData.type == 'issue') {
        /*let res = await TimeSheetService.findAll({ issue_id: issueData.issueId });
        res = lodash.orderBy(res, ['id'], ['desc']);
        let timesheetData = res[0]
        let data = {}
        data.id = timesheetData.id
        data.end_date = moment(new Date()).utcOffset("+05:30").format('YYYY/MM/DD HH:mm:ss')
        let end_date = moment(new Date()).tz('utc')
        data.stage = 'completed'
        let start_date = moment(timesheetData.start_date, true).tz('Asia/Kolkata')
        var hours = end_date.diff(start_date, 'seconds') / 60 / 60;
        data.actual_hrs = hours ? parseFloat(hours.toFixed(2)) : 0
        console.log(data, 'dhnefhnwi3finalal')
        await TimeSheetService.update(data);
        localStorage.removeItem('timer')
        this.$store.commit('SET_IN_PROGRESS', false)
        return issueData.issueId*/
        let $time = { "issue_id": issueData.issueId }
        await TimerService.processTime($time, issueData.type, false)
        localStorage.removeItem('timer')
        this.$store.commit('SET_IN_PROGRESS', false)
        return issueData.issueId


      }
      else {
        if (issueData && issueData.previousIssueId) {
          return issueData.previousIssueId
        }
        else {
          return null
        }
      }
    },
    menuShow() { },
    extraAvatar() {
      if (
        localStorage.getItem("selectedWorkSpaceId") ==
        localStorage.getItem("workSpaceId")
      ) {
        this.avatarName = localStorage.getItem("avatarName");
        this.show = true;
      } else {
        this.show = false;
      }
    },

    async getProjectData() {
      try {
        let workSpaceId = localStorage.getItem("workSpaceId");
        let res = await ProjectService.getWorkSpaceProject({
          work_space_id: workSpaceId,
        });
        this.projectData = res.length > 0 ? res : [];
        let projectId = localStorage.getItem("_PROJECT_ID_");
        if (!projectId && this.projectData.length > 0) {
          localStorage.setItem("_PROJECT_ID_", this.projectData[0].id);
          this.activeWorkSpace("pj", this.projectData[0].id);
        } else {
          this.activeWorkSpace("pj", projectId);
        }
      } catch (e) {
        this.projectData = [];
      }
    },
    async getAccountData() {
      try {
        let workSpaceId = localStorage.getItem("workSpaceId");
        let res = await AccountService.getAccountByIssue({
          work_space_id: workSpaceId,
        });
        this.accountData = res.length > 0 ? res : [];
        let accountId = localStorage.getItem("_ACCOUNT_ID_");
        if (!accountId && this.accountData.length > 0) {
          localStorage.setItem("_ACCOUNT_ID_", this.accountData[0].id);
          this.activeWorkSpace("ac", this.accountData[0].id);
        } else {
          this.activeWorkSpace("ac", accountId);
        }
      } catch (e) {
        this.accountData = [];
      }
    },

    async getAvatarMenu() {

      let res = await WorkSpaceService.getWorkSpaceByUser({ active: 1 });
      if (res && res.length > 0) {

        for (let i = 0; i < res.length; i++) {
          if (i > 3) {
            if (res[i].id != localStorage.getItem("workSpaceId")) {
              this.addedMenu.push(res[i]);
            }
          }
        }
        // console.log("greater 4", this.addedMenu);
        return this.addedMenu;
      }
    },

    getAvatarLabel() {
      if (this.workSpaceData.length > this.maxAvatarLabelCount) {
        if (
          localStorage.getItem("selectedWorkSpaceId") ==
          localStorage.getItem("workSpaceId")
        ) {
          this.maxAvatarLabelCount = 5;
          let count = this.workSpaceData.length - this.maxAvatarLabelCount;
          return "+" + count;
        } else {
          let count = this.workSpaceData.length - this.maxAvatarLabelCount;
          return "+" + count;
        }
      } else {
        return "+" + "0";
      }
    },

    getRandomColor(index) {
      const availableColors = ["#C7D4E7", "#E7CED1", "#FDEFCA", "#F5D4DF"];
      if (index >= 0 && index < availableColors.length) {
        return availableColors[index];
      }
      return "#000000";
    },

    async getWorkSpaceData() {
      try {
        let res = await WorkSpaceService.getWorkSpaceByUser({ active: 1 });
        this.workSpaceData = res;
        let selectId = localStorage.getItem("workSpaceId");
        this.workSpaceData.map((k) => (k.active = false));
        if (!selectId && this.workSpaceData.length > 0) {
          localStorage.setItem("workSpaceId", this.workSpaceData[0].id);
          this.$store.commit("WORK_SPACE_ID", this.workSpaceData[0].id);
          this.activeWorkSpace("ws", this.workSpaceData[0].id);
        } else {
          this.activeWorkSpace("ws", selectId);
          this.$store.commit("WORK_SPACE_ID", selectId);
        }
      } catch (e) {
        console.log(e);
      }
    },

    async activeWorkSpace(type, id) {
      if (type == "ws") {
        this.workSpaceData.map((k) => {
          if (k.id == parseInt(id)) {
            k.active = true;
          } else {
            k.active = false;
          }
        });
        this.workSpaceData = [...this.workSpaceData];
      }
      if (type == "pj") {
        this.projectData.map((k) => {
          this.$store.commit("PROJECT_ID", id);
          if (k.id == parseInt(id)) {
            k.active = true;
          } else {
            k.active = false;
          }
        });
        this.projectData = [...this.projectData];
      }
      if (type == "ac") {
        this.accountData.map((k) => {
          if (k.id == parseInt(id)) {
            this.$store.commit("ACCOUNT_ID", id);
            k.active = true;
          } else {
            k.active = false;
          }
        });
        this.accountData = [...this.accountData];
      }
    },

    selectProject(data) {
      this.show = false;
      localStorage.setItem("_PROJECT_ID_", data.id);
      this.activeWorkSpace("pj", data.id);
      // location.reload();
    },
    selectAccount(data) {
      this.show = false;
      localStorage.setItem("_ACCOUNT_ID_", data.id);
      this.activeWorkSpace("ac", data.id);
      // location.reload();
    },
    // for extra avatar
    selectWorkSpaceMenu(data) {
      this.show = true;
      localStorage.setItem("selectedWorkSpaceId", data.id);
      // let name = data.name ? data.name.slice(0,1) : '0'
      // this.avatarName = name
      localStorage.setItem("avatarName", data.name);
      localStorage.setItem("workSpaceId", data.id);
      this.activeWorkSpace(data.id);
      // location.reload();
    },
    getRendomColor() {
      return this.colors[Math.floor(Math.random() * this.colors.length)];
    },
    async startTimer($type, $taskSelected) {
      let timeStatus = this.$store.getters.getTimerStatus;
      if (timeStatus) {
        this.breakLoader = $type == 'break' ? true : false
        this.$store.commit('SET_TIME_STATUS', false)
        console.log($taskSelected, "### taskSelected")
        let timerStatus = localStorage.getItem('timer')
        let $timerStatus = JSON.parse(timerStatus)
        if ($timerStatus) {
          await this.closeTimer($timerStatus, $type, $type == 'break' ? 'break' : $taskSelected)
          timerStatus = null
        }
        let userDetails = localStorage.getItem("user_details")
        userDetails = JSON.parse(userDetails)
        await UserService.update({
          id: userDetails.id,
          stage: `in ${$type}`,
        });

        if (!timerStatus || $timerStatus.type != $type) {
          this.workTimingId = JSON.parse(localStorage.getItem("_WORK_TIMING_"))
          if (this.workTimingId && this.workTimingId.id) {
            let issueId = await this.updateTimeSheet()
            this.taskType = $type
            await this.addDialog3($type, issueId, $taskSelected)

            // await TimerService.processTime($time,$type,true)

          }
        }
        else {
          this.timerDialog = true;
        }
        this.$store.commit('SET_TIME_STATUS', true)
        this.breakLoader = false
      }

    },

    async addDialog3(value, issueId, $taskSelected) {
      //  alert(issueId)
      // alert(this.workTimingId.id)
      this.$store.commit('SET_HIDE_TIMER', true)
      this.timerTitle = value == 'meeting' ? 'Meeting' : 'Break'
      this.timerDialog = true;
      // let userData = JSON.parse(localStorage.getItem("user_details"))
      let data = {}
    /*   data.company_id = userData.company_id
      data.customer_id = 0
      data.issue_id = 0
      data.project_id = 0
      data.resource_id = userData.id
      data.stage = 'pending'
      data.start_date = moment(new Date()).utcOffset("+05:30").format('YYYY/MM/DD HH:mm:ss')
      data.entry_date = moment(new Date()).utcOffset("+05:30").format('YYYY/MM/DD HH:mm:ss')
      let task = await TaskService.findAll({ task_type: value })
      data.task_id = task[0].id
     */  let $timer = {
        type: value,
        start: JSON.stringify(moment(new Date())),
        taskId: data.task_id,
      }
      if ($timer.type.toLowerCase() == 'meeting') {
        $timer.meetingName = this.meetingData && this.meetingData.name ? this.meetingData.name : null
        $timer.code = $taskSelected && $taskSelected.code ? $taskSelected.code : null
        $timer.remarks_required = $taskSelected.remarks_required ? $taskSelected.remarks_required : 0
        this.timerName = $timer.type && $timer.type.toLowerCase() == 'meeting' ? $timer.meetingName : $timer.type
      }
      if (issueId) {
        $timer.previousIssueId = issueId
        await IssueService.update({ id: issueId, stage: 'pending' })

      }
      data.description = value
      localStorage.setItem("timer", JSON.stringify($timer))
      this.$store.commit('SET_IN_PROGRESS', true)
      await TimerService.processTime(data, value, true, $taskSelected)
      .then(res => this.user_activity_id = res.data.data.id)
      // console.log(this.user_activity_id,"this.user_activity_id!!!")
      let timer = JSON.parse(localStorage.getItem("timer"))
      localStorage.removeItem("timer")
      timer.user_activity_id = this.user_activity_id
      localStorage.setItem("timer",JSON.stringify(timer))
      // console.log(timer,"timer!!!")
      let status2 = this.$store.getters.getReloadTheIssue;
      this.$store.commit("RELOAD_THE_ISSUE", !status2);


    },

    async closeTimer($event,type,$taskSelected) {
      // alert('topmenu')
      console.log($event,"\n",type,"\n",$taskSelected,"$event,type,$taskSelected!!")
      this.timerDialog = false;
      this.meetingTimer = false
      this.$store.commit('SET_IN_PROGRESS', false)
      //await this.updateTimeSheet2($event);
      let $time = {}
      await TimerService.processTime($time, $event.type, false, $taskSelected, null, $event && $event.issueId && $event.issueId > 0 ? $event.issueId : $event.previousIssueId && $event.previousIssueId > 0 ? $event.previousIssueId : null)
      this.$store.commit('SET_IN_PROGRESS', false)
      if ($event.previousIssueId && !type) {
        // alert('previousiddd')
        let userData = JSON.parse(localStorage.getItem("user_details"))
        let data = {}
        let res = await IssueService.findOne($event.previousIssueId);
        data.company_id = userData.company_id
        data.customer_id = res[0].account_id
        data.description = res[0].name
        data.issue_id = res[0].id
        data.project_id = res[0].project_id
        data.resource_id = userData.id
        data.stage = 'pending'
        data.task_id = res[0].task_id
        await TimerService.processTime(data, 'issue', true)
        let $start = moment(new Date())
        let $timer = {
          "type": 'issue',
          "issueId": $event.previousIssueId,
          "start": JSON.stringify($start)
        }
        localStorage.setItem("timer", JSON.stringify($timer))
        this.$store.commit('SET_IN_PROGRESS', true)
        let status2 = this.$store.getters.getReloadTheIssue;
        this.$store.commit("RELOAD_THE_ISSUE", !status2);
      } else {
        await this.createTimeSheet($event, type)
      }
      this.$store.commit('SET_HIDE_TIMER', false)
    },
    minimizeTimer() {
      this.meetingTimer = true
      this.timerDialog = false;
      this.$store.commit('SET_IN_PROGRESS', true)
      this.$store.commit('SET_HIDE_TIMER', false)
    },
    openTimerDialog() {
      let timerData = JSON.parse(localStorage.getItem("timer"))
      if (timerData && timerData.type != 'issue') {
        this.timerDialog = true
        this.meetingTimer = false;
        this.timerTitle = timerData.type
        this.taskType = timerData.type
        this.$store.commit('SET_IN_PROGRESS', false)
      }
      else {
        this.timerDialog = false
      }
    },
    async updateTimeSheet2($timer) {
      let res = await TimeSheetService.findAll({ task_id: $timer.taskId, "stage": "pending" });
      res = lodash.orderBy(res, ['id'], ['desc']);
      let timesheetData = res[0]
      let data = {}
      data.id = timesheetData.id
      data.end_date = moment(new Date()).utcOffset("+05:30").format('YYYY/MM/DD HH:mm:ss')
      let end_date = moment(new Date()).tz('utc')
      data.stage = 'completed'
      let start_date = moment(timesheetData.start_date, true).tz('Asia/Kolkata')
      var hours = end_date.diff(start_date, 'seconds') / 60;
      data.actual_hrs = hours ? parseFloat(hours.toFixed(2)) : 0
      await TimeSheetService.update(data);
      this.$store.commit('SET_IN_PROGRESS', false)
    },
    async createTimeSheet(issueData, type) {
      if (issueData && issueData.previousIssueId && !type) {
        // alert(issueData.previousIssueId)
        let userData = JSON.parse(localStorage.getItem("user_details"))
        let data = {}
        let res = await IssueService.findOne(issueData.previousIssueId);
        data.company_id = userData.company_id
        data.customer_id = res[0].account_id
        data.description = res[0].name
        data.issue_id = res[0].id
        data.project_id = res[0].project_id
        data.resource_id = userData.id
        data.stage = 'pending'
        data.task_id = res[0].task_id
        data.start_date = moment(new Date()).utcOffset("+05:30").format('YYYY/MM/DD HH:mm:ss')
        data.entry_date = moment(new Date()).utcOffset("+05:30").format('YYYY/MM/DD HH:mm:ss')
        await TimerService.processTime(data, "issue", true);
        // await TimeSheetService.create(data);
        let $start = moment(new Date()).utcOffset("+05:30").format('YYYY/MM/DD HH:mm:ss')
        let $timer = {
          "type": 'issue',
          "issueId": issueData.previousIssueId,
          "start": JSON.stringify($start)
        }
        localStorage.setItem("timer", JSON.stringify($timer))
        this.$store.commit('SET_IN_PROGRESS', true)
      }
    },
    // closeDialog() {
    //   this.dialog = false;
    // },
    openSideBar() {
      this.$refs.NavigationDrawer.drawer = true;
    },
    openTeamStatus() {
      this.$refs.TeamStatus.drawer = !this.$refs.TeamStatus.drawer;
      this.$refs.Notification.drawer = false
    },
    openReceivedReplay() {
      this.$refs.ReceivedReplay.drawer = !this.$refs.ReceivedReplay.drawer;
      if (this.$refs.ReceivedReplay.drawer) {
        this.$refs.ReceivedReplay.getUsers();
      }
      this.$refs.Notification.drawer = false
    },
    closedMenu() {
      this.menu = false
    },
    openNotification() {
      this.workTimingId = JSON.parse(localStorage.getItem("_WORK_TIMING_"))
      if (this.workTimingId && this.workTimingId.id) {
        this.$refs.Notification.drawer = !this.$refs.Notification.drawer;
        this.$refs.TeamStatus.drawer = false
        this.$refs.ReceivedReplay.drawer = false
      }
    },
  },
};
</script>


<style scoped>
/* ─── Navbar ─── */
.top-navbar {
  background: linear-gradient(135deg, #1a3a6e 0%, #1e4d9b 35%, #2060c0 70%, #2d7ae0 100%) !important;
  border-bottom: 1px solid rgba(99,179,255,0.25) !important;
  border-top: 1px solid rgba(255,255,255,0.12) !important;
  /* box-shadow:
    0 8px 32px rgba(0,8,30,0.6),
    0 1px 0 rgba(99,179,255,0.08),
    inset 0 1px 0 rgba(255,255,255,0.05),
    inset 0 -1px 0 rgba(0,0,0,0.2) !important; */
  position: fixed !important;
  right: 0 !important;
  border-radius: 0 0 14px 14px !important;
  backdrop-filter: blur(20px) saturate(1.4) !important;
  -webkit-backdrop-filter: blur(20px) saturate(1.4) !important;
}

.top-navbar :deep(.v-toolbar__content) {
  overflow: visible;
  position: relative;
}
.top-navbar :deep(.v-toolbar__append) {
  flex-shrink: 0;
  overflow: visible;
  white-space: nowrap;
}

/* ─── Left section ─── */
.tn-left {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 16px;
  gap: 0;
  flex-shrink: 1;
  min-width: 0;
  overflow: visible;
}

/* ─── Center — My Space ─── */
.tn-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: all;
  white-space: nowrap;
  transition: left 0.2s ease;
}
.tn-center--shifted {
  left: 50%;
}
.tn-center-cluster {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* User card */
.tn-user-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 12px 5px 5px;
  border-radius: 12px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(99,179,255,0.25);
  transition: background 0.2s;
}
.tn-user-card:hover { background: rgba(255,255,255,0.14); }

/* Avatar */
.tn-avatar {
  position: relative;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
}
.tn-avatar__text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg,#3b82f6,#8b5cf6);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.4px;
  z-index: 1;
}
.tn-avatar__ring {
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  background: conic-gradient(#3b82f6,#8b5cf6,#06b6d4,#3b82f6);
  z-index: 0;
  animation: tn-ring-spin 4s linear infinite;
  opacity: 0.7;
}
@keyframes tn-ring-spin { to { transform: rotate(360deg); } }
.tn-avatar__status {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 9px;
  height: 9px;
  background: #22c55e;
  border-radius: 50%;
  border: 2px solid #0d2a5e;
  box-shadow: 0 0 6px rgba(34,197,94,0.8);
  z-index: 2;
}

/* Identity */
.tn-identity {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.tn-identity__greet {
  font-size: 0.6rem;
  color: rgba(186,224,255,0.8);
  font-weight: 400;
  letter-spacing: 0.3px;
  line-height: 1;
  white-space: nowrap;
}
.tn-identity__name {
  font-size: 0.82rem;
  color: #ffffff;
  font-weight: 700;
  white-space: nowrap;
  letter-spacing: 0.1px;
}
.tn-identity__name-row {
  display: flex;
  align-items: center;
  gap: 4px;
}
.tn-edit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: none;
  background: rgba(56,189,248,0.1);
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s, transform 0.15s;
  padding: 0;
}
.tn-edit-btn:hover {
  background: rgba(56,189,248,0.25);
  transform: scale(1.15);
}

/* Separator */
.tn-sep {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent, rgba(99,179,255,0.35), transparent);
  margin: 0 8px;
  flex-shrink: 0;
}
.tn-sep--r { margin: 0 4px; }

.tn-timer-wrap {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  min-width: 90px;
  justify-content: center;
}

/* Meta badges */
.tn-meta {
  display: flex;
  align-items: center;
  gap: 6px;
}
.tn-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 20px;
  white-space: nowrap;
}
.tn-badge--role {
  color: #a5b4fc;
  background: rgba(99,102,241,0.18);
  border: 1px solid rgba(165,180,252,0.2);
}
.tn-badge--shift {
  color: #6ee7b7;
  background: rgba(16,185,129,0.12);
  border: 1px solid rgba(110,231,183,0.2);
}
.tn-online-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 0 rgba(34,197,94,0.6);
  animation: tn-pulse 2.2s ease-out infinite;
  flex-shrink: 0;
}
@keyframes tn-pulse {
  0%   { box-shadow: 0 0 0 0 rgba(34,197,94,0.6); }
  70%  { box-shadow: 0 0 0 6px rgba(34,197,94,0); }
  100% { box-shadow: 0 0 0 0 rgba(34,197,94,0); }
}

/* Date navigator */
.tn-date-nav {
  display: flex;
  align-items: center;
  gap: 1px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(99,179,255,0.3);
  border-radius: 10px;
  padding: 3px;
  flex-shrink: 0;
}
.tn-arrow-btn {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.14s;
  flex-shrink: 0;
}
.tn-arrow-btn:hover { background: rgba(99,179,255,0.2); }
.tn-arrow-btn--off { cursor: not-allowed; opacity: 0.25; }
.tn-date-display {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 2px 10px;
  min-width: 108px;
  justify-content: center;
}
.tn-date-display--clickable {
  cursor: pointer;
  border-radius: 7px;
  transition: background 0.14s;
}
.tn-date-display--clickable:hover {
  background: rgba(99,179,255,0.2);
}
.tn-date-display__text {
  font-size: 0.72rem;
  font-weight: 700;
  color: #ffffff;
  white-space: nowrap;
  letter-spacing: 0.2px;
}
.tn-datepicker-card {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid rgba(99,179,255,0.2);
  box-shadow: 0 12px 40px rgba(0,8,30,0.55) !important;
}

/* ─── Pill group ─── */
.tn-pill-group {
  display: flex;
  align-items: center;
  gap: 1px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(99,179,255,0.25);
  border-radius: 11px;
  padding: 3px 4px;
}

/* Pill button */
.tn-pill-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 30px;
  min-width: 30px;
  padding: 0 7px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.14s, transform 0.12s;
  flex-shrink: 0;
  position: relative;
}
.tn-pill-btn::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 8px;
  background: radial-gradient(circle at center, rgba(99,179,255,0.25), transparent 70%);
  opacity: 0;
  transition: opacity 0.14s;
}
.tn-pill-btn:hover::after { opacity: 1; }
.tn-pill-btn:hover { transform: translateY(-1px); }
.tn-pill-btn:active { transform: translateY(0); }

.tn-pill-btn--text { padding: 0 10px; }
.tn-pill-btn__label {
  font-size: 0.73rem;
  font-weight: 600;
  color: rgba(220,240,255,0.95);
  letter-spacing: 0.2px;
  white-space: nowrap;
}
.tn-pill-btn__img {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
  opacity: 0.75;
  transition: opacity 0.14s;
}
.tn-pill-btn:hover .tn-pill-btn__img { opacity: 1; }
.tn-pill-btn__pi {
  color: rgba(210,235,255,0.85);
  font-size: 15px;
  transition: color 0.14s;
}
.tn-pill-btn:hover .tn-pill-btn__pi { color: #7dd3fc; }

/* Add button */
.tn-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 9px;
  background: linear-gradient(135deg, rgba(99,102,241,0.5), rgba(139,92,246,0.4));
  border: 1px solid rgba(165,180,252,0.25);
  box-shadow: 0 2px 10px rgba(99,102,241,0.3), inset 0 1px 0 rgba(255,255,255,0.1);
  cursor: pointer;
  margin-left: 4px;
  transition: transform 0.14s, box-shadow 0.14s, background 0.14s;
  flex-shrink: 0;
}
.tn-add-btn:hover {
  background: linear-gradient(135deg, rgba(99,102,241,0.75), rgba(139,92,246,0.65));
  box-shadow: 0 4px 18px rgba(99,102,241,0.5), inset 0 1px 0 rgba(255,255,255,0.15);
  transform: translateY(-1px);
}

/* Profile button */
.tn-profile-btn {
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  border: 2px solid rgba(165,180,252,0.35);
  box-shadow: 0 0 0 3px rgba(99,102,241,0.15), 0 4px 14px rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0 10px 0 5px;
  transition: box-shadow 0.18s, transform 0.18s;
  flex-shrink: 0;
}
.tn-profile-btn:hover {
  box-shadow: 0 0 0 4px rgba(99,102,241,0.35), 0 6px 20px rgba(0,0,0,0.4);
  transform: translateY(-1px);
}
.tn-profile-btn__initials {
  color: #fff;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.4px;
}
.tn-profile-btn__status {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 8px;
  height: 8px;
  background: #22c55e;
  border-radius: 50%;
  border: 2px solid #0d2a5e;
  box-shadow: 0 0 5px rgba(34,197,94,0.8);
}

/* ─── Meeting button ─── */
.tn-meeting-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 36px;
  padding: 0 11px 0 5px;
  border-radius: 12px;
  border: 1px solid rgba(34,211,238,0.45);
  background: linear-gradient(
    135deg,
    rgba(6,182,212,0.28) 0%,
    rgba(14,165,233,0.22) 50%,
    rgba(56,189,248,0.18) 100%
  );
  box-shadow:
    0 0 0 1px rgba(34,211,238,0.14),
    0 4px 18px rgba(6,182,212,0.28),
    inset 0 1px 0 rgba(255,255,255,0.16),
    inset 0 -1px 0 rgba(0,0,0,0.18);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition:
    transform 0.2s cubic-bezier(0.34,1.56,0.64,1),
    box-shadow 0.2s ease,
    border-color 0.2s ease;
  flex-shrink: 0;
}

/* live pulse ring */
.tn-meeting-pulse {
  position: absolute;
  inset: -2px;
  border-radius: 13px;
  border: 1.5px solid rgba(34,211,238,0.55);
  animation: tn-meeting-ring 2.4s ease-out infinite;
  pointer-events: none;
}
@keyframes tn-meeting-ring {
  0%   { opacity: 0.9; transform: scale(1); }
  70%  { opacity: 0;   transform: scale(1.12); }
  100% { opacity: 0;   transform: scale(1.12); }
}

/* shimmer sweep */
.tn-meeting-shimmer {
  position: absolute;
  top: 0; left: -100%;
  width: 55%;
  height: 100%;
  background: linear-gradient(
    105deg,
    transparent,
    rgba(255,255,255,0.13) 50%,
    transparent
  );
  animation: tn-meeting-sweep 2.8s ease-in-out infinite;
  pointer-events: none;
  border-radius: 12px;
}
@keyframes tn-meeting-sweep {
  0%   { left: -80%; }
  55%  { left: 130%; }
  100% { left: 130%; }
}

.tn-meeting-btn:hover {
  transform: translateY(-2px) scale(1.02);
  border-color: rgba(103,232,249,0.75);
  box-shadow:
    0 0 0 1px rgba(34,211,238,0.28),
    0 8px 28px rgba(6,182,212,0.45),
    0 0 20px rgba(56,189,248,0.32),
    inset 0 1px 0 rgba(255,255,255,0.2),
    inset 0 -1px 0 rgba(0,0,0,0.12);
}
.tn-meeting-btn:active {
  transform: translateY(0) scale(1);
}

/* icon badge */
.tn-meeting-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: linear-gradient(145deg, #22d3ee, #0891b2);
  box-shadow:
    0 2px 10px rgba(6,182,212,0.6),
    inset 0 1px 0 rgba(255,255,255,0.3),
    inset 0 -1px 0 rgba(0,0,0,0.18);
  flex-shrink: 0;
  transition: box-shadow 0.2s, transform 0.2s;
}
.tn-meeting-btn:hover .tn-meeting-icon-wrap {
  box-shadow:
    0 4px 16px rgba(34,211,238,0.8),
    inset 0 1px 0 rgba(255,255,255,0.35);
  transform: rotate(8deg) scale(1.1);
}

/* text stack */
.tn-meeting-text-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1;
  gap: 1px;
}
.tn-meeting-eyebrow {
  font-size: 0.48rem;
  font-weight: 700;
  color: rgba(103,232,249,0.72);
  letter-spacing: 1px;
  text-transform: uppercase;
}
.tn-meeting-label {
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.2px;
  white-space: nowrap;
  text-shadow: 0 1px 8px rgba(0,0,0,0.35);
  background: linear-gradient(90deg, #a5f3fc, #67e8f9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

>>>.v-menu>.v-overlay__content>.v-card,
>>>.v-menu>.v-overlay__content>.v-sheet,
>>>.v-menu>.v-overlay__content>.v-list {
  background: rgb(var(--v-theme-surface));
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.18);
  width: 50% !important;
  margin-left: 15%;
  margin-top: 1%;
  overflow: auto;
}
>>>.mdi-check::before { color: #03b603; content: "\F012C"; }
>>>.work-space-menu { cursor: pointer; }
>>>.menus { cursor: pointer; }
>>>.menus:hover { background-color: #f0f9ff; }

/* ══════════════════════════════════
   My Space — premium button (app blue theme)
══════════════════════════════════ */
.tn-myspace-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px 0 5px;
  border-radius: 12px;
  border: 1px solid rgba(99,179,255,0.45);
  background: linear-gradient(
    135deg,
    rgba(26,58,110,0.82) 0%,
    rgba(30,77,155,0.72) 50%,
    rgba(32,96,192,0.62) 100%
  );
  box-shadow:
    0 0 0 1px rgba(56,145,255,0.18),
    0 4px 20px rgba(14,50,120,0.45),
    inset 0 1px 0 rgba(255,255,255,0.18),
    inset 0 -1px 0 rgba(0,0,0,0.22);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition:
    transform 0.2s cubic-bezier(0.34,1.56,0.64,1),
    box-shadow 0.2s ease,
    border-color 0.2s ease;
  flex-shrink: 0;
}

/* shimmer sweep animation */
.tn-myspace-shimmer {
  position: absolute;
  top: 0; left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(
    105deg,
    transparent,
    rgba(255,255,255,0.14) 50%,
    transparent
  );
  animation: tn-shimmer-slide 3s ease-in-out infinite;
  pointer-events: none;
  border-radius: 12px;
}
@keyframes tn-shimmer-slide {
  0%   { left: -80%; }
  60%  { left: 130%; }
  100% { left: 130%; }
}

.tn-myspace-btn:hover {
  transform: translateY(-2px) scale(1.02);
  border-color: rgba(125,211,252,0.7);
  box-shadow:
    0 0 0 1px rgba(99,179,255,0.32),
    0 8px 28px rgba(14,50,120,0.55),
    0 0 22px rgba(45,122,224,0.38),
    inset 0 1px 0 rgba(255,255,255,0.22),
    inset 0 -1px 0 rgba(0,0,0,0.12);
}
.tn-myspace-btn:active {
  transform: translateY(0) scale(1);
}

/* icon badge */
.tn-myspace-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: linear-gradient(145deg, #60a5fa, #1d4ed8);
  box-shadow:
    0 2px 10px rgba(29,78,216,0.6),
    inset 0 1px 0 rgba(255,255,255,0.3),
    inset 0 -1px 0 rgba(0,0,0,0.18);
  flex-shrink: 0;
  transition: box-shadow 0.2s, transform 0.2s;
}
.tn-myspace-btn:hover .tn-myspace-icon-wrap {
  box-shadow:
    0 4px 16px rgba(59,130,246,0.8),
    inset 0 1px 0 rgba(255,255,255,0.35);
  transform: rotate(-8deg) scale(1.1);
}

/* text stack */
.tn-myspace-text-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1;
  gap: 1px;
}
.tn-myspace-eyebrow {
  font-size: 0.48rem;
  font-weight: 700;
  color: rgba(125,211,252,0.72);
  letter-spacing: 1px;
  text-transform: uppercase;
}
.tn-myspace-label {
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.2px;
  white-space: nowrap;
  text-shadow: 0 1px 8px rgba(0,0,0,0.35);
  background: linear-gradient(90deg, #bfdbfe, #7dd3fc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* chevron */
.tn-myspace-chevron {
  color: rgba(125,211,252,0.65) !important;
  transition: transform 0.22s cubic-bezier(0.34,1.56,0.64,1), color 0.2s;
  flex-shrink: 0;
  margin-left: -2px;
}
.tn-myspace-btn:hover .tn-myspace-chevron {
  transform: translateY(3px);
  color: rgba(186,230,253,0.95) !important;
}

@media (max-width: 1600px) {
  .tn-sep {
    margin: 0 5px;
  }
  .tn-user-card {
    gap: 7px;
    padding: 4px 8px 4px 4px;
  }
  .tn-identity__name {
    font-size: 0.76rem;
  }
  .tn-badge {
    font-size: 0.54rem;
    padding: 2px 6px;
  }
  .tn-date-display {
    min-width: 90px;
    padding: 2px 6px;
  }
  .tn-date-display__text {
    font-size: 0.68rem;
  }
  .tn-center--shifted {
    left: 38%;
  }
}

@media (max-width: 1400px) {
  /* Hide role/shift badges at very tight widths to reclaim space */
  .tn-badge--role {
    display: none;
  }
  .tn-sep:nth-child(2) {
    display: none;
  }
  .tn-center--shifted {
    left: 40%;
  }
}

@media (max-width: 1200px) {
}
</style>
